import { useRouter } from 'next/router'

import { useTranslation } from '@mc/i18n'
import { paths } from '@mc/paths'

import Link from 'components/Link'
import { articlesPath, mainContentPath } from 'libs/paths'

import { trackLogoClick } from '../events'
import { MCLogo } from '../MCLogo/MCLogo'

interface NavTitleProp {
  className?: string
}

export const NavTitle = ({ className = '' }: NavTitleProp) => {
  const { t } = useTranslation('@mc/next')
  const { asPath } = useRouter()
  const IS_ARTICLES_PAGE = asPath.startsWith(paths.articles)

  return (
    <div className={`col-auto d-flex align-items-center ${className}`}>
      <Link
        className='d-none d-sm-flex mc-sr-only mc-sr-only-focusable mc-text-h7 mc-mr-4'
        href={mainContentPath()}
        isBasic
      >
        {t('nav.cta.skip')}
      </Link>
      <Link href={paths.root} onClick={trackLogoClick} passHref>
        <span className='mc-sr-only'>{t('nav.cta.logo')}</span>
        <div className='d-flex'>
          <MCLogo />
        </div>
      </Link>
      {IS_ARTICLES_PAGE && (
        <>
          <span className='mc-opacity--hinted mc-mx-2'>|</span>
          <Link className='mc-text-h7' href={articlesPath()}>
            {t('nav.cta.articles')}
          </Link>
        </>
      )}
    </div>
  )
}
